import { css } from 'linaria';

export namespace Styles {
  export const reviewTextArea = css`
    --textareaMinHeight: 60px;
  `;

  export const reviewTextAreaTabletMinus = css`
    --textareaMinHeight: 30px;
    fieldset {
      border-top: 0;
      border-right: 0;
      border-left: 0;
      border-radius: 0;
    }
    textarea {
      padding-top: 18px !important;
      margin: 0px !important;
      line-height: 15px !important;
      resize: none;
    }
    legend {
      display: none !important;
    }
  `;

  // textarea mobile view fix
  // fronton textarea hasn't mobile view
  // important is used to cover fronton styles
}
